export const statusDisponibles=[
    {status:"Activo",value:1},
    {status:"Inactivo",value:2},
]